import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
export const shouldClearSession = (response) => (
  response?.status === 401 && response?.data?.code === 'SESSION_INVALID'
);
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true,
  validateStatus: () => true,
});

apiClient.interceptors.request.use(
  (config) => {
    const csrfToken = cookies.get('invoice_csrf');
    if (csrfToken && !['get', 'head', 'options'].includes(String(config.method || 'get').toLowerCase())) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const axiosInstance = async (url, method, data, config = {}) => {
  const requestConfig = {
    ...config,
    method,
    url,
    ...(method !== 'get' && method !== 'delete' ? { data } : { params: data }),
  };

  try {
    const response = await apiClient.request(requestConfig);

    if (shouldClearSession(response) && window.location.pathname !== '/login') {
      cookies.remove('invoice_csrf', { path: '/' });

      window.location.href = '/login';

      return;
    }

    if (response?.status === 403 && response?.data?.code === 'PASSWORD_CHANGE_REQUIRED' && window.location.pathname !== '/change-password') {
      window.location.href = '/change-password';
      return;
    }

    return response;
  } catch (error) {
    if (!axios.isCancel(error) && error?.code !== 'ERR_CANCELED') {
      console.error('Network Error:', error);
    }

    throw error;
  }
};

export default axiosInstance;
